<template>
	<section id="slider" class="mb-12">
		<swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
			<swiper-slide
				v-for="(item, i) in data"
				:key="i"
			>
        <a v-if="item.url" :href="item.url" target="_blank">
          <img v-lazy="item.file_url" alt="Banner" class="w-full" style="border-radius: 1.3rem" />
        </a>
        <img v-else v-lazy="item.file_url" alt="Banner" class="w-full" style="border-radius: 1.3rem" />
				
			</swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
		</swiper>
	</section>
</template>
<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  props: ['data'],
  data: () => ({
    swiperOption: {
      slidesPerView: 2,
      spaceBetween: 30,
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 40
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    }
  }),
  components: {
    swiperSlide,
    swiper
  }
}
</script>
<style>
	[dir=ltr] .swiper-container-horizontal>.swiper-pagination-bullets, [dir=ltr] .swiper-pagination-custom, [dir=ltr] .swiper-pagination-fraction {
		text-align:left;
	}
</style>